import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

const useScrollRestoration = () => {
  const location = useLocation()
  const prevLocation = useRef('')
  const isInitialMount = useRef(true)

  useEffect(() => {
    // No hacer scroll en el montaje inicial
    if (isInitialMount.current) {
      isInitialMount.current = false
      prevLocation.current = location.pathname + location.search
      return
    }

    // Solo actuar si cambió pathname o search (ignorar hash changes)
    const currentKey = location.pathname + location.search
    if (prevLocation.current === currentKey) return
    prevLocation.current = currentKey

    // Buscar contenedor de scroll de layout autenticado
    const scrollContainer = document.querySelector(
      '.auth-layout__scrollable-content',
    )

    // Scroll instantáneo al inicio
    if (scrollContainer) {
      scrollContainer.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    }
  }, [location])
}

export default useScrollRestoration
